import { render, staticRenderFns } from "./AddBrandVoiceByLink.vue?vue&type=template&id=97ea8e2c"
import script from "./AddBrandVoiceByLink.vue?vue&type=script&lang=js"
export * from "./AddBrandVoiceByLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports